import { Link, useMatch, useNavigate } from 'react-router-dom'
import { Fragment, useContext, useEffect, useState } from 'react';
import henceforthApi from '../../utils/henceforthApi';
import { sellerdetails } from '../../context/interfaces';
import { GlobalContext, handleError } from '../../context/Provider';
import { toast } from 'react-toastify'
import Spinner from '../../components/BootstrapCompo';
import Swal from 'sweetalert2';
import profile_placeholder from '../../assets/images/pages/profile_placeholder.png'
import BreadCrumb from '../../components/common/BreadCrumb';
import SignedImage from '../../components/SignedImage';

const SellerRequestDetail = () => {

    const { authState } = useContext(GlobalContext);
    const match: any = useMatch("/seller-request/:id")
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [verifying, setVerifying] = useState(false)
    const [state, setState] = useState<sellerdetails>()
    const [selectedImage, setSelectedImage] = useState<string | null>(null)
    const [showRejectModal, setShowRejectModal] = useState(false)
    const [rejectionReason, setRejectionReason] = useState('')

    let breadCrumbPath = [
        { name: 'Home', url: `/`, active: '' },
        { name: 'Seller Requests', url: `/seller-requests/1`, active: '' },
        { name: 'View Request', url: ``, active: 'not-allowed' }
    ]

    const fetchSellerDetails = async () => {
        try {
            setLoading(true)
            let apiRes = await henceforthApi.Seller.details(match?.params?.id)
            setState(apiRes)
        } catch (error) {
            handleError(error)
        } finally {
            setLoading(false)
        }
    }

    const handleVerify = async (action: string) => {
        if (action === 'reject') {
            setShowRejectModal(true)
        } else {
            Swal.fire({
                title: "Are you sure?",
                text: `Are you sure want to ${action.toLowerCase()} this seller!`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: action === 'approve' ? "#3085d6" : "#d33",
                cancelButtonColor: "#6c757d",
                confirmButtonText: `Yes, ${action.toLowerCase()} it!`,
            }).then(async (result: any) => {
                if (result.isConfirmed) {
                    try {
                        setVerifying(true)
                        let apiRes = await henceforthApi.Seller.verify(match?.params?.id, action)
                        toast.success((action === 'approve' ? 'Seller verified successfully' : 'Seller rejected successfully'))
                        navigate('/seller-requests/1')
                    } catch (error) {
                        handleError(error)
                    } finally {
                        setVerifying(false)
                    }
                }
            })
        }
    }

    const handleRejectConfirm = async () => {
        if (!rejectionReason.trim()) {
            toast.error('Please enter a reason for rejection')
            return
        }

        try {
            setVerifying(true)
            let apiRes = await henceforthApi.Seller.verify(match?.params?.id, 'reject', rejectionReason.trim() || undefined)
            toast.success('Seller rejected successfully')
            setShowRejectModal(false)
            setRejectionReason('')
            navigate('/seller-requests/1')
        } catch (error) {
            handleError(error)
        } finally {
            setVerifying(false)
        }
    }

    useEffect(() => {
        fetchSellerDetails()
    }, [match?.params?.id])

    return (
        <Fragment>
            <BreadCrumb pathNameDeclare={breadCrumbPath} />
            <div className='page-spacing'>
                <section className='change-password'>
                    <div className="container-fluid">
                        <div className="row gy-3 justify-content-center">
                            <div className="col-sm-12 col-md-7 col-lg-6 col-xl-5 col-xxl-4 px-xs-0">
                                <div className="common-card">
                                    <div className="common-card-title">
                                        <h5>Seller Request Details</h5>
                                    </div>
                                    <div className="common-card-content">
                                        {loading ? <div className='d-flex justify-content-center my-5'><Spinner /></div> :
                                            <>
                                                <div className="profile-image">
                                                    <SignedImage
                                                        src={state?.data?.image || ""}
                                                        fallback={profile_placeholder}
                                                        className='img-fluid'
                                                        size="small"
                                                    />
                                                </div>
                                                <div className="profile-info mb-4">
                                                    <div className='mb-3'>
                                                        <label className='fw-semibold text-muted small text-uppercase'>Verification Status</label>
                                                        <p className="mb-0">
                                                            {state?.data?.is_admin_verified === "pending" && <span className="badge bg-warning">Pending</span>}
                                                            {state?.data?.is_admin_verified === "approve" && <span className="badge bg-success">Verified</span>}
                                                            {state?.data?.is_admin_verified === "reject" && <span className="badge bg-danger">Rejected</span>}
                                                            {!state?.data?.is_admin_verified && <span className="badge bg-secondary">Not Available</span>}
                                                        </p>
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className='fw-semibold text-muted small text-uppercase'>Full Name</label>
                                                        <h5 className='mb-0 text-dark'>{state?.data?.name || "Not Available"}</h5>
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className='fw-semibold text-muted small text-uppercase'>Email Address</label>
                                                        <p className="d-flex align-items-center mb-0 text-dark"><i className='fa fa-envelope me-2 text-theme'></i>{state?.data?.email || "Not Available"}</p>
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className='fw-semibold text-muted small text-uppercase'>Phone Number</label>
                                                        <p className="d-flex align-items-center mb-0 text-dark"><i className='fa fa-phone-square me-2 text-success'></i>+{state?.data?.country_code}-{state?.data?.phone_number || "Not Available"}</p>
                                                    </div>
                                                    {state?.data?.shop_name && <div className='mb-3'>
                                                        <label className='fw-semibold text-muted small text-uppercase'>Shop Name</label>
                                                        <p className="mb-0 text-dark"><i className='fa fa-shopping-bag me-2 text-warning'></i>{state?.data?.shop_name}</p>
                                                    </div>}
                                                </div>

                                                {/************************************** Seller Documents  *************************************/}
                                                {state?.data?.documents && state?.data?.documents.length > 0 && (
                                                    <div className="my-4">
                                                        <h6 className="fw-bold mb-3">
                                                            Submitted Documents
                                                        </h6>
                                                        <div className="row gy-3">
                                                            {state?.data?.documents?.map((doc: any, index: number) => (
                                                                <div key={index} className="col-md-6">
                                                                    <div className="document-card border rounded-3 overflow-hidden shadow-sm h-100">
                                                                        <div className="bg-theme-light-color bg-opacity-10 p-2 border-bottom">
                                                                            <h6 className="fw-bold mb-0 text-theme text-uppercase small">
                                                                                {doc?.type?.replace('_', ' ')}
                                                                            </h6>
                                                                        </div>
                                                                        <div className="document-card-body p-3">
                                                                            <div className="document-images row g-2">
                                                                                {doc?.images?.front && (
                                                                                    <div className="col-6">
                                                                                        <div
                                                                                            className="document-image-wrapper position-relative overflow-hidden rounded border"
                                                                                            onClick={() => setSelectedImage(doc?.images?.front)}
                                                                                            role="button"
                                                                                            title="Click to view full image"
                                                                                        >
                                                                                            <SignedImage
                                                                                                src={doc?.images?.front || ""}
                                                                                                fallback={profile_placeholder}
                                                                                                alt={`${doc?.type} front`}
                                                                                                className='img-fluid w-100'
                                                                                                style={{ height: '120px', objectFit: 'cover', cursor: 'pointer', transition: 'transform 0.3s' }}
                                                                                                size="medium"
                                                                                            />
                                                                                            <div className="document-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                                                                                style={{ background: 'rgba(0,0,0,0.5)', opacity: 0, transition: 'opacity 0.3s' }}>
                                                                                                <i className='fa fa-search-plus text-white fa-2x'></i>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="text-center mt-2">
                                                                                            <small className="text-muted">Front</small>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                                {doc?.images?.back && (
                                                                                    <div className="col-6">
                                                                                        <div
                                                                                            className="document-image-wrapper position-relative overflow-hidden rounded border"
                                                                                            onClick={() => setSelectedImage(doc?.images?.back)}
                                                                                            role="button"
                                                                                            title="Click to view full image"
                                                                                        >
                                                                                            <SignedImage
                                                                                                src={doc?.images?.back || ""}
                                                                                                fallback={profile_placeholder}
                                                                                                alt={`${doc?.type} back`}
                                                                                                className='img-fluid w-100'
                                                                                                style={{ height: '120px', objectFit: 'cover', cursor: 'pointer', transition: 'transform 0.3s' }}
                                                                                                size="medium"
                                                                                            />
                                                                                            <div className="document-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                                                                                style={{ background: 'rgba(0,0,0,0.5)', opacity: 0, transition: 'opacity 0.3s' }}>
                                                                                                <i className='fa fa-search-plus text-white fa-2x'></i>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="text-center mt-2">
                                                                                            <small className="text-muted">Back</small>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}

                                                {/************************************** Rejection Reason Display  *************************************/}
                                                {state?.data?.rejection_reason && state?.data?.is_admin_verified === "reject" && (
                                                    <div className="my-4">
                                                        <div className="alert alert-danger mb-0">
                                                            <h6 className="alert-heading fw-bold mb-2">
                                                                <i className='fa fa-exclamation-circle me-2'></i>Rejection Reason
                                                            </h6>
                                                            <p className="mb-0">{state?.data?.rejection_reason}</p>
                                                        </div>
                                                    </div>
                                                )}

                                                {(state?.data?.is_admin_verified === "pending" || state?.data?.is_admin_verified === "reject") && (
                                                    <div className="profile-button">
                                                        <div className='d-flex gap-3'>
                                                            <button
                                                                type='button'
                                                                className='btn btn-success flex-grow-1 py-2 fw-semibold'
                                                                onClick={() => handleVerify('approve')}
                                                                disabled={verifying}
                                                            >
                                                                {verifying ? <Spinner /> : <><i className='fa fa-check-circle me-1'></i> Approve</>}
                                                            </button>

                                                            <button
                                                                type='button'
                                                                className='btn btn-danger flex-grow-1 py-2 fw-semibold'
                                                                onClick={() => handleVerify('reject')}
                                                                disabled={verifying}
                                                            >
                                                                {verifying ? <Spinner /> : <><i className='fa fa-times-circle me-1'></i> Reject</>}
                                                            </button>

                                                        </div>
                                                    </div>
                                                )}
                                            </>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/************************************** Image Modal  *************************************/}
            {selectedImage && (
                <div
                    className="document-modal-overlay"
                    onClick={() => setSelectedImage(null)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        animation: 'fadeIn 0.3s ease'
                    }}
                >
                    <div
                        className="document-modal-content"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            position: 'relative',
                            animation: 'zoomIn 0.3s ease'
                        }}
                    >
                        <button
                            className="document-modal-close"
                            onClick={() => setSelectedImage(null)}
                            style={{
                                position: 'absolute',
                                top: '-40px',
                                right: '0',
                                background: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '40px',
                                height: '40px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                fontSize: '20px',
                                fontWeight: 'bold',
                                color: '#333',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
                                zIndex: 10000,
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'rotate(90deg) scale(1.1)';
                                e.currentTarget.style.backgroundColor = '#f8f9fa';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'rotate(0deg) scale(1)';
                                e.currentTarget.style.backgroundColor = 'white';
                            }}
                        >
                            <i className='fa fa-times'></i>
                        </button>
                        <SignedImage
                            src={selectedImage || ""}
                            fallback={profile_placeholder}
                            alt="Document Full View"
                            className='img-fluid'
                            style={{

                                width: '90vw',
                                height: '90vh',
                                maxWidth: '90vw',
                                maxHeight: '90vh',
                                objectFit: 'contain',
                                borderRadius: '8px',
                                boxShadow: '0 10px 40px rgba(0,0,0,0.5)'
                            }}
                            size="original"
                        />
                    </div>
                </div>
            )}

            {/************************************** Rejection Reason Modal  *************************************/}
            {showRejectModal && (
                <div
                    className="modal fade show"
                    style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
                    tabIndex={-1}
                    role="dialog"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <i className='fa fa-exclamation-triangle text-danger me-2'></i>
                                    Rejection Reason
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setShowRejectModal(false)
                                        setRejectionReason('')
                                    }}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label className="form-label fw-semibold">
                                        Reason for Rejection <span className="text-muted small">(Optional)</span>
                                    </label>
                                    <textarea
                                        className="form-control"
                                        rows={5}
                                        value={rejectionReason}
                                        onChange={(e) => setRejectionReason(e.target.value)}
                                        placeholder="Enter the reason for rejecting this seller (optional)..."
                                        style={{ resize: 'none' }}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowRejectModal(false)
                                        setRejectionReason('')
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={handleRejectConfirm}
                                    disabled={verifying}
                                >
                                    {verifying ? <Spinner /> : <>Confirm Rejection</>}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    )
}
export default SellerRequestDetail;